import createIcon from '../../createIcon';

/**
 * @component @name ViewSidebar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMjBIMlY0SDE2VjIwWk0xOCA4SDIyVjRIMThWOFpNMTggMjBIMjJWMTZIMThWMjBaTTE4IDE0SDIyVjEwSDE4VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewSidebar = createIcon('ViewSidebar', [
  [
    'path',
    { d: 'M16 20H2V4H16V20ZM18 8H22V4H18V8ZM18 20H22V16H18V20ZM18 14H22V10H18V14Z', key: 'i4ejtc' },
  ],
]);

export default ViewSidebar;
